<app-premium-icon
  class="premium-icon"
  [iconSize]="premiumIconSize"
  [altDesign]="true"
>
</app-premium-icon>

<span class="premium-text">
  {{ 'LABEL.PREMIUM_FEATURE' | translate }}
</span>
